// extracted by mini-css-extract-plugin
export default {"container":"FetchLoading_container__Av-na"};